import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ChecklistItem from '../shared/ChecklistItem';

// ─── Default checklist items ─────────────────────────────────────────────────
const DEFAULT_ITEMS = [
  { label: 'Insurance pre-authorisation obtained', checked: false },
  { label: 'Consent forms signed by patient/guardian', checked: false },
  { label: 'Pre-operative assessment completed', checked: false },
  { label: 'Blood cross-match ordered and available', checked: false },
  { label: 'Fasting instructions given and confirmed', checked: false },
  { label: 'Patient informed of date/time and preparation', checked: false },
];

// ─── Styles ──────────────────────────────────────────────────────────────────
const useStyles = makeStyles(() => ({
  root: {
    padding: 20,
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    color: '#333',
    marginBottom: 4,
  },
  progressText: {
    fontSize: '0.8rem',
    color: '#888',
    marginTop: 12,
    textAlign: 'right',
  },
  progressBar: {
    height: 4,
    borderRadius: 2,
    backgroundColor: '#e0e0e0',
    marginTop: 8,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: 2,
    backgroundColor: '#4CAF50',
    transition: 'width 0.3s ease',
  },
}));

/**
 * Pre-admission checklist component.
 *
 * Props:
 *  - items: array of { label, checked }
 *  - onChange(index, checked): callback when an item is toggled
 *  - disabled: boolean
 */
const PreAdmissionChecklist = ({ items, onChange, disabled = false }) => {
  const classes = useStyles();
  const checklistItems = items && items.length > 0 ? items : DEFAULT_ITEMS;
  const completedCount = checklistItems.filter((item) => item.checked).length;
  const totalCount = checklistItems.length;
  const progressPct = totalCount > 0 ? (completedCount / totalCount) * 100 : 0;

  return (
    <Paper className={classes.root} elevation={1}>
      <Typography className={classes.title}>Pre-Admission Checklist</Typography>
      <Divider style={{ margin: '8px 0 4px' }} />

      {checklistItems.map((item, idx) => (
        <ChecklistItem
          key={idx}
          label={item.label}
          checked={item.checked}
          onChange={(e) => {
            if (onChange) {
              onChange(idx, e.target.checked);
            }
          }}
          disabled={disabled}
        />
      ))}

      {/* Progress bar */}
      <div className={classes.progressBar}>
        <div
          className={classes.progressFill}
          style={{ width: `${progressPct}%` }}
        />
      </div>
      <Typography className={classes.progressText}>
        {completedCount}/{totalCount} complete
      </Typography>
    </Paper>
  );
};

export default PreAdmissionChecklist;
